module.exports = __webpack_public_path__ + "media/images/svgs/jobs/operator-859db81566279b6822f0566dfd01771e.svg";